/**
 * Max file size in megabytes.
 * Default: 10MB
 * @type {number}
 */
export const MAX_FILE_SIZE = 10;

export const MBtoBytes = (mb) => Math.floor(mb * 1024 * 1024);
